var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgApiIconApiFocus = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "241px",
    height: "192px",
    viewBox: "0 0 241 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "API_icon_API_focus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "API_icon_API_focus",
    transform: "translate(0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#1A4480",
    x: 5,
    y: 5.5,
    width: 230,
    height: 180
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_Over",
    fill: "#A48923",
    stroke: "#A48923",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,6 C10.4771525,6 6,10.4771525 6,16 L6,176 C6,181.522847 10.4771525,186 16,186 L224,186 C229.522847,186 234,181.522847 234,176 L234,16 C234,10.4771525 229.522847,6 224,6 L16,6 Z M9,10 L231,10 L231,182 L9,182 L9,10 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.3780158,132.49271 C61.0167866,132.49271 49.2753147,122.059775 48.2072652,109.243181 C47.0543375,95.9668296 56.7587348,84.7487727 70.8414279,82.8885275 L70.8414279,82.8248689 C72.7653317,76.9541329 75.4177727,70.3902258 82.9860708,66.1463202 C87.6904761,63.5137408 92.9864537,62.1191658 98.3773014,62.0933905 C103.439847,62.0992903 108.426172,63.3270666 112.912678,65.6724175 C119.759512,57.1138747 128.770738,52.5941153 139.083428,52.5941153 C140.951608,52.5973955 142.816971,52.7392482 144.664164,53.0185059 C159.935151,55.3031417 169.526377,63.6282696 172.398087,77.1663282 C172.862581,79.2969331 173.130131,81.4657442 173.197356,83.6453573 C184.889315,87.0404817 192.415174,97.14805 191.920052,108.804644 C191.474442,119.414408 182.859314,129.140024 171.407842,131.919782 C169.887851,132.260681 168.332357,132.417417 166.774912,132.386612 L165.629057,132.386612 L164.504422,132.386612 C156.794661,132.386612 149.066037,132.386612 141.318552,132.386612 L119.992927,132.386612 C115.579265,132.386612 111.165603,132.370108 106.751942,132.3371 L106.207307,132.3371 C101.793645,132.3371 97.3163251,132.287588 92.8177852,132.287588 C85.8577802,132.287588 80.1709468,132.344173 74.9155772,132.47149 L74.3780158,132.49271 Z M98.4268137,70.2487622 C94.4164202,70.2596249 90.4759223,71.2995461 86.9824152,73.2690083 C82.4555826,75.7799857 80.5670447,79.4297445 78.6714335,85.2934073 L78.5794823,85.5975538 C78.1763112,86.8990182 77.1011885,90.3790207 72.454112,90.8882893 C62.5092267,91.9846316 55.5845876,99.5741493 56.3343442,108.571229 C57.0416618,117.129772 65.3243507,124.358557 74.3921622,124.358557 L74.7953332,124.358557 C80.1355809,124.238313 85.8931461,124.174655 92.930956,124.174655 C97.4719349,124.174655 101.991694,124.174655 106.454868,124.224167 L106.858039,124.224167 C111.252839,124.25246 115.647639,124.268964 120.042439,124.273679 L141.375137,124.273679 C149.108476,124.273679 156.8371,124.273679 164.561008,124.273679 L165.784667,124.273679 L166.817351,124.273679 C167.726693,124.300944 168.636058,124.220217 169.526377,124.033191 C177.497846,122.095141 183.4959,115.54538 183.792973,108.472204 C184.125412,100.635126 178.954921,93.8024378 170.926866,91.4965825 C167.156863,90.4073134 165.19052,87.9953604 165.084423,84.317309 C165.046713,82.4732288 164.828765,80.6372552 164.433691,78.8355977 C162.276372,68.7138831 155.415391,62.8997325 143.468797,61.110219 C141.989056,60.8875905 140.494942,60.7741135 138.99855,60.7707066 C131.027081,60.7707066 124.250979,64.3072945 118.861219,71.3804704 C117.354632,73.3538864 115.579265,74.3512042 113.598776,74.3512042 C112.239837,74.2995471 110.915096,73.9106323 109.743895,73.2194961 C106.264699,71.2927345 102.35438,70.2780469 98.3773014,70.2699818 L98.4268137,70.2487622 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3780158,129.889781 C62.4880072,129.889781 51.7438531,120.447091 50.7889744,109.023912 C49.7492175,96.9853669 58.8170289,86.8212132 71.7963066,85.3924317 C72.8289903,85.2792609 72.8855757,85.081212 73.2109418,83.9777965 L73.3241126,83.6099914 C75.1419188,77.9514507 77.4902132,72.1868124 84.2238766,68.4451024 C92.9331543,63.5171733 103.579365,63.4769787 112.325604,68.3390048 C113.605849,69.0463223 113.634142,68.9968101 114.390972,68.0065655 C121.952197,58.1041193 132.27196,53.8602138 144.218554,55.6214346 C158.322467,57.7433873 167.17101,65.3753441 169.795158,77.7321823 C170.263698,79.8376549 170.524298,81.9840584 170.573207,84.1404796 C170.608573,85.201456 170.785403,85.6824319 172.419306,86.1563347 C182.951265,89.2048735 189.727367,98.2726849 189.288831,108.712692 C188.88566,118.197821 181.105166,126.904901 170.785403,129.408805 C169.099978,129.759064 167.376325,129.889824 165.65735,129.79783 L164.525642,129.79783 C152.916203,129.79783 141.311479,129.79783 129.71147,129.79783 L119.992927,129.79783 C115.480241,129.79783 110.962839,129.781326 106.440722,129.748317 C96.0926656,129.698805 85.3909506,129.635147 74.8802113,129.889781 L74.3780158,129.889781 Z M98.4268137,67.6458335 C93.9659723,67.6557987 89.5822966,68.8101666 85.6950972,70.9985189 C80.418508,73.9268137 78.1975308,78.1707192 76.1463098,84.5365774 L76.0472853,84.8690167 C75.6582606,86.1209688 75.071187,88.0236531 72.1145995,88.3490192 C60.7409328,89.6009713 52.8189758,98.3929289 53.7243423,108.804644 C54.5731234,118.898066 64.1997158,127.194901 74.8377722,126.968559 C85.4758287,126.742218 96.1138852,126.777584 106.483161,126.834169 C110.995847,126.834169 115.508533,126.883681 120.02122,126.883681 L129.739763,126.883681 C141.339772,126.883681 152.942138,126.883681 164.546861,126.883681 C164.935886,126.883681 165.331984,126.883681 165.721009,126.883681 C167.192139,126.970714 168.668356,126.868496 170.113451,126.579535 C179.188335,124.379777 186.028097,116.825625 186.381755,108.627814 C186.763707,99.5670761 180.836385,91.6521923 171.634184,89.0209709 C168.967596,88.2499948 167.743937,86.7787742 167.666132,84.2677968 C167.627458,82.2781302 167.390514,80.2972758 166.958814,78.3546218 C164.582227,67.1719307 156.801734,60.5019259 143.836603,58.5497294 C132.851961,56.9087526 123.755856,60.6716821 116.774632,69.8102253 C114.857801,72.3212028 113.068288,72.0807148 110.974628,70.9419335 C107.115257,68.8145203 102.784133,67.6885739 98.3773014,67.6670531 L98.4268137,67.6458335 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#1A4480",
    strokeWidth: 10,
    strokeLinejoin: "round",
    points: "61.8514214 143.003449 84.6129012 143.003449 84.6129012 106.583667"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#1A4480",
    strokeWidth: 10,
    strokeLinejoin: "round",
    points: "174.350283 143.003449 151.588803 143.003449 151.588803 106.583667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.77195,139.099056 L117.77195,106.583667",
    id: "Path",
    stroke: "#1A4480",
    strokeWidth: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#1A4480",
    strokeWidth: 10,
    strokeLinejoin: "round",
    points: "74.8589918 47.996551 97.6133985 47.996551 97.6133985 84.4163335"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#1A4480",
    strokeWidth: 10,
    strokeLinejoin: "round",
    points: "161.993445 47.996551 139.231965 47.996551 139.231965 84.4163335"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "61.8514214 143.003449 84.6129012 143.003449 84.6129012 109.618059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8170499,109.780742 C87.8170499,108.018952 86.3888372,106.59074 84.6270476,106.59074 C82.865258,106.59074 81.4370453,108.018952 81.4370453,109.780742 C81.4370453,111.542532 82.865258,112.970744 84.6270476,112.970744 C86.3872235,112.966854 87.81316,111.540918 87.8170499,109.780742 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 56.9426373,
    cy: 143.293449,
    r: 4.19439328
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "174.350283 143.003449 151.588803 143.003449 151.588803 109.618059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.778806,109.780742 C154.778806,108.490507 154.001587,107.327316 152.809564,106.833564 C151.617542,106.339812 150.245465,106.612736 149.333131,107.52507 C148.420797,108.437404 148.147874,109.809481 148.641625,111.001503 C149.135377,112.193525 150.298568,112.970744 151.588803,112.970744 C153.348979,112.966854 154.774916,111.540918 154.778806,109.780742 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 179.259067,
    cy: 143.293449,
    r: 4.19439328
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.77195,139.099056 L117.77195,112.680744",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "122.008782 113.91855 117.77195 106.583667 113.54219 113.91855"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 117.418291,
    cy: 143.293449,
    r: 4.19439328
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "74.8589918 47.996551 97.6133985 47.996551 97.6133985 81.381941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4233961,81.219258 C94.4205356,82.5136372 95.1984277,83.6820225 96.393733,84.1786822 C97.5890383,84.675342 98.965871,84.4022636 99.8811376,83.4869971 C100.796404,82.5717306 101.069482,81.1948978 100.572823,79.9995925 C100.076163,78.8042872 98.9077776,78.0263951 97.6133985,78.0292557 C95.8532226,78.0331456 94.4272861,79.4590821 94.4233961,81.219258 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 69.9502077,
    cy: 47.7065508,
    r: 4.19439328
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "161.993445 47.996551 139.231965 47.996551 139.231965 81.381941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.041963,81.219258 C136.041963,82.9810476 137.470175,84.4092603 139.231965,84.4092603 C140.993755,84.4092603 142.421967,82.9810476 142.421967,81.219258 C142.421967,79.4574683 140.993755,78.0292557 139.231965,78.0292557 C137.471789,78.0331456 136.045853,79.4590821 136.041963,81.219258 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 166.902229,
    cy: 47.7065508,
    r: 4.19439328
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgApiIconApiFocus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/API_icon_API_focus.cbeed95f0d87d0e56c676d6ba882c704.svg";